import { Variant } from '@material-ui/core/styles/createTypography';

export const ICON_WITH_CIRCLE_SIZE_VALUES = {
  small: {
    circleSize: 24,
    fontSize: 16,
  },
  medium: {
    circleSize: 40,
    fontSize: 24,
  },
  large: {
    circleSize: 60,
    fontSize: 30,
  },
};

export const TEXT_SIZE_VARIANTS = {
  small: 'subtitle2' as Variant,
  medium: 'subtitle2' as Variant,
  large: 'body' as Variant,
};
